import React from 'react'
import container from './container'

const UserChangeStatus = props => {
    const { children, childProps } = props
    return React.cloneElement(children, childProps)
}

export default container(UserChangeStatus)
